// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SmcZ0","left":"styles_left__2Maz3","desktopActions":"styles_desktopActions__2qqc4","title":"styles_title__1S6GQ"};